/* =====================================================================
   LUNEOR — product page (split layout, particles, variants, AJAX cart)
   ===================================================================== */
(() => {
  function initProduct(root) {
    if (!root || root._init) return; root._init = true;
    const { T, $, $$, clamp, lerp, mouse, toast, Cart, flyToCart, REDUCE, FINE } = window.Luneor;
    let VARIANTS = [];
    try { VARIANTS = JSON.parse($('[data-variants]', root).textContent); } catch (e) {}
    const form = $('#pform', root), input = $('[data-variant-input]', root);
    const atc = $('[data-atc]', root), atcLabel = $('[data-atc-label]', root), qtyIn = $('[data-qty]', root);
    let V = VARIANTS.find(v => v.id == (input && input.value)) || VARIANTS[0];

    /* particles behind the product */
    const fxCanvas = $('[data-fx]', root);
    const fx = fxCanvas && window.LuneorParticles ? window.LuneorParticles(fxCanvas, { shape: root.dataset.shape, color: root.dataset.c, cx: innerWidth > 860 ? .7 : .5, cy: innerWidth > 860 ? .5 : .28, scale: innerWidth > 860 ? .95 : .7 }) : null;
    try { if (localStorage.getItem('luneor_world') === 'everyday') fx && fx.setSoft(1); } catch (e) {}

    /* main image + Halloween crow burst (replaces the old glitch) */
    const layer = $('[data-layer]', root), reflect = $('[data-reflect]', root), obj = $('[data-obj]', root);
    let lastCrows = 0;
    const crows = n => { const t = performance.now(); if (t - lastCrows < 1800) return; lastCrows = t; window.LuneorCrows && window.LuneorCrows.burst(obj, n ? { count: n } : {}); };
    setTimeout(() => crows(), 600);
    let curSrc = null;
    function float(src) { curSrc = src; }
    function showImg(src) {
      if (!layer || !src) return;
      layer.style.backgroundImage = reflect.style.backgroundImage = `url("${src}")`;
      crows(7);
      $$('[data-thumb]', root).forEach(t => t.classList.toggle('on', t.dataset.thumb === src));
      float(src);
    }
    if (layer) { const m = layer.style.backgroundImage.match(/url\(["']?(.*?)["']?\)/); if (m) float(m[1]); }
    $$('[data-thumb]', root).forEach(t => t.addEventListener('click', () => showImg(t.dataset.thumb)));

    /* read more → open description */
    $('[data-readmore]', root)?.addEventListener('click', e => {
      e.preventDefault(); const d = $('[data-desc-item]', root);
      if (d && !d.classList.contains('open')) d.querySelector('button').click();
      const t = $('#pdetails'); t && scrollTo({ top: t.getBoundingClientRect().top + scrollY - 70, behavior: 'smooth' });
    });

    /* variants */
    const fieldsets = $$('[data-option]', root);
    const selected = () => fieldsets.map(f => ($('.sw button.on', f) || $('.sw button', f)).dataset.value);
    function updLabel() {
      if (!atcLabel) return;
      const q = Math.max(1, +qtyIn.value || 1);
      atcLabel.textContent = V && V.available ? `${T.addToCart}${q > 1 ? ' (' + q + ')' : ''} — ${V.price}` : T.soldOut;
    }
    function update() {
      const opts = selected();
      V = VARIANTS.find(v => v.options.every((o, i) => o === opts[i])) || V;
      if (!V) return;
      input.value = V.id;
      fieldsets.forEach((f, i) => { const s = $('[data-opt-val]', f); if (s) s.textContent = opts[i]; });
      $('[data-price]', root).textContent = V.price;
      const cmp = $('[data-compare]', root), save = $('[data-save]', root);
      cmp.hidden = !V.compare; cmp.textContent = V.compare; save.hidden = !V.save; save.textContent = `${T.save} ${V.save}%`;
      atc.disabled = !V.available; updLabel();
      const sv = $('[data-satc-v]', root); if (sv) sv.textContent = (VARIANTS.length > 1 ? V.title + ' · ' : '') + V.price;
      if (V.img) showImg(V.img);
      const u = new URL(location.href); u.searchParams.set('variant', V.id); history.replaceState(null, '', u);
    }
    fieldsets.forEach(f => $$('.sw button', f).forEach(b => b.addEventListener('click', () => {
      $$('.sw button', f).forEach(x => { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b); });
      update();
    })));
    $('[data-qm]', root)?.addEventListener('click', () => { qtyIn.value = Math.max(1, (+qtyIn.value || 1) - 1); updLabel(); });
    $('[data-qp]', root)?.addEventListener('click', () => { qtyIn.value = Math.min(99, (+qtyIn.value || 1) + 1); updLabel(); });
    qtyIn?.addEventListener('change', updLabel);

    /* add to cart: the image animation starts on click, the cart opens once
       both the animation and the add request are done */
    let busy = false;
    async function add(fromEl) {
      if (!form || atc.disabled || busy) return;
      busy = true; atc.classList.add('loading');
      const src = curSrc || ($('[data-thumb]', root) || {}).dataset?.thumb;
      const flown = new Promise(res => { try { (window.Luneor.flyToCart || flyToCart)(fromEl, src, res); } catch (e) { res(); } setTimeout(res, 1600); });
      try {
        await Cart.add(form);
        await flown;
        Cart.open();
        toast(`✦ <b>${$('.pname', root)?.textContent || ''}</b>${VARIANTS.length > 1 ? ' — ' + V.title : ''} ${T.added}`);
      } catch (err) { toast(err.message); }
      atc.classList.remove('loading'); busy = false;
    }
    // handle the click on the button itself so cart apps listening to the form submit can't swallow it
    atc?.addEventListener('click', e => { e.preventDefault(); e.stopImmediatePropagation(); add(atc); });
    form?.addEventListener('submit', e => { e.preventDefault(); add(atc); });
    $('[data-satc-btn]', root)?.addEventListener('click', e => { e.preventDefault(); e.stopImmediatePropagation(); add(e.currentTarget); });

    /* lightbox */
    const lb = $('[data-lb]', root), lbImg = $('[data-lb-img]', root);
    let lbI = 0;
    const tiles = () => $$('[data-gal] .ph[data-full]', root);
    const lbShow = i => { const t = tiles(); if (!t.length) return; lbI = (i + t.length) % t.length; lbImg.src = t[lbI].dataset.full; lb.classList.add('on'); };
    root.addEventListener('click', e => { const t = e.target.closest('[data-gal] .ph[data-full]'); if (t) lbShow(tiles().indexOf(t)); });
    obj?.addEventListener('click', () => { const k = $$('[data-thumb]', root).findIndex(t => t.dataset.thumb === curSrc); lbShow(Math.max(0, k)); });
    $('[data-lb-x]', root)?.addEventListener('click', () => lb.classList.remove('on'));
    $('[data-lb-p]', root)?.addEventListener('click', () => lbShow(lbI - 1));
    $('[data-lb-n]', root)?.addEventListener('click', () => lbShow(lbI + 1));
    addEventListener('keydown', e => { if (!lb.classList.contains('on')) return; if (e.key === 'Escape') lb.classList.remove('on'); if (e.key === 'ArrowLeft') lbShow(lbI - 1); if (e.key === 'ArrowRight') lbShow(lbI + 1); });

    /* gallery strip: drag to scroll */
    const gal = $('[data-gal]', root);
    if (gal && FINE) {
      let down = false, sx = 0, sl = 0, moved = false;
      gal.addEventListener('mousedown', e => { down = true; moved = false; sx = e.pageX; sl = gal.scrollLeft; gal.classList.add('drag'); });
      addEventListener('mouseup', () => { down = false; gal.classList.remove('drag'); });
      gal.addEventListener('mousemove', e => { if (!down) return; const dx = e.pageX - sx; if (Math.abs(dx) > 4) moved = true; gal.scrollLeft = sl - dx; });
      gal.addEventListener('click', e => { if (moved) { e.stopPropagation(); e.preventDefault(); } }, true);
    }

    /* next-piece preview */
    const next = $('[data-next]');
    if (next) { const nph = $('.ph', next); nph && next.addEventListener('mousemove', e => { const r = next.getBoundingClientRect(); nph.style.transform = `translate(${e.clientX - r.left - 110}px, ${e.clientY - r.top - 140}px) rotate(${(e.clientX / innerWidth - .5) * 12}deg)`; }); }

    /* loop: tilt, sticky bar, steps */
    const pobj = $('[data-pobj]', root), buy = $('[data-buy]', root), satc = $('[data-satc]', root);
    let tx = 0, ty = 0;
    function frame(now) {
      const vh = innerHeight;
      if (pobj) {
        const mx = FINE ? mouse.x / innerWidth - .5 : Math.sin(now / 1600) * .2, my = FINE ? mouse.y / innerHeight - .5 : Math.cos(now / 2100) * .15;
        tx = lerp(tx, mx, .06); ty = lerp(ty, my, .06);
        const sp = clamp(-buy.getBoundingClientRect().top / vh, 0, 1);
        pobj.style.transform = `translate(${tx * -26}px, ${ty * -18 + sp * 60}px) rotateY(${tx * 18}deg) rotateX(${ty * -12}deg) rotate(${tx * 4}deg)`;
      }
      if (satc && buy) {
        const n = $('[data-next]') || document.querySelector('footer');
        satc.classList.toggle('on', buy.getBoundingClientRect().bottom < vh * .3 && (!n || n.getBoundingClientRect().top > vh * .6));
      }
      $$('[data-steps]').forEach(st => {
        const r = st.getBoundingClientRect(), sp = clamp((vh * .8 - r.top) / (vh * .5), 0, 1), els = $$('.step', st);
        st.style.setProperty('--sp', sp);
        els.forEach((el, i) => el.classList.toggle('on', sp >= (els.length > 1 ? i / (els.length - 1) : 0) * .98));
      });
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  const boot = (r = document) => r.querySelectorAll('[data-product-page]').forEach(initProduct);
  document.addEventListener('luneor:ready', () => boot());
  document.addEventListener('shopify:section:load', e => window.Luneor && boot(e.target));
})();
